import React from 'react';
import queryString from 'query-string';
import { WithLocalize } from '../../containers/I18nProvider';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import { Container, Col } from 'reactstrap';
import Helmet from 'react-helmet';
import favicon from './img/favicon.ico';

import './style.scss';
import image from './img/mainbg.jpg'
import LoginForm from './loginForm';

import 'bootstrap/dist/css/bootstrap.css';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.title = 'ETB';
    document.body.style.backgroundImage = `url(${image})`;
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundAttachment = 'fixed';
  }

  componentWillUnmount() {
    document.body.style.backgroundImage = null;
    document.body.style.backgroundRepeat = null;
    document.body.style.backgroundSize = null;
    document.body.style.backgroundAttachment = null;
  }

  render() {
    const { translate } = this.props;
    return (
      <Container fluid={true} className="body-etb">
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        </Helmet>
        <Col sm="2"></Col>
        <Col sm="3">
          {
            this._validateParams()
              ? <LoginForm
                api={this.api}
                location={this.props.location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </Col>
        <footer id="footer">
          <p>{translate("footer")}</p>
        </footer>
      </Container>
    )
  }
}

export default WithLocalize(Login);
